import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { PostData } from '../../services/PostData';
import { GetData } from '../../services/GetData';
import {
	Row,
	Col,
	Button,
	ButtonDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Card,
	CardHeader,
	CardFooter,
	CardBody,
	Collapse,
	Form,
	FormGroup,
	FormText,
	Label,
	Input,
	InputGroup,
	InputGroupAddon,
	InputGroupText,
	Table
} from 'reactstrap';
import $ from 'jquery';
import AcademicPage from '../../views/AcademicPage/';

class SetExam extends Component {

	/** set property value **/
	constructor(props) {
		super(props);
		this.state = {
			examname: '',
			sdate: '',
			edate: '',
			accyear: [],
			acyear: '',
			_message: '',
			alertClass: '',
			_redirect: false,
			posts: [],
			isedit: 0,
		}
		this.onChange = this.onChange.bind(this);
		this.onAcChange = this.onAcChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onUpdateSubmit = this.onUpdateSubmit.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.onClick = this.onClick.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
	}

	/** set value **/
	onChange(e) {
		this.setState({ [e.target.name]: e.target.value });
		//this.getdata();
	}

	onAcChange(e) {
		this.setState({ [e.target.name]: e.target.value });
		this.getdata();
	}

	handleEditClick(id) {
		var d = this.state.posts;
		var index = d.findIndex(function (obj) {
			return (obj.id == id);
		});

		this.setState({ isedit: 1, id: id, examname: d[index]['exam'], department: d[index]['department'], sdate: d[index]['startdate'], edate: d[index]['enddate'] })
	}

	onClick(e) {

		document.getElementById("exameditform").reset();
		this.setState({ isedit: 0, examname: '', department: '', sdate: '', edate: '' });
		document.getElementById("examform").reset();
		this.getacyear();
	}

	onSubmit(e) {
		e.preventDefault();
		$("#showLoader").show();
		PostData('exam/addexam', this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson.status == '1') {
				this.setState({
					_message: 'Exam Created Successfully!..',
					alertClass: 'alert alert-success',
				});
				document.getElementById("examform").reset();
				this.getacyear();
			}
			else {

				this.setState({
					_message: 'Already Added',
					alertClass: 'alert alert-danger'
				});
				document.getElementById("examform").reset();
				this.getacyear();
			}
		});

	}

	handleClick(dd) {

		this.state.id = dd;

		if (window.confirm("Do you want to Delete?")) {
			$("#showLoader").show();
			PostData('exam/deleteexam', this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if (responseJson.status == '1') {
					this.setState({
						_message: 'Exam Removed Successfullly',
						alertClass: 'alert alert-success'
					});
					this.getdata();
				}
				else {

					this.setState({
						_message: 'Error',
						alertClass: 'alert alert-danger'
					});
				}
			});
		}
	}

	onUpdateSubmit(e) {
		e.preventDefault();
		$("#showLoader").show();
		PostData('exam/updatexam', this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			this.getdata();
			document.getElementById("exameditform").reset();
			if (responseJson.status == '1') {
				this.setState({
					_message: 'Exam Updated Successfullly',
					alertClass: 'alert alert-success',
					isedit: 0,
				});

			}
			else {

				this.setState({
					_message: 'Error',
					alertClass: 'alert alert-danger'
				});
			}
		});
	}

	onUpdate(dt) {

		this.state.idd = dt;
		this.setState({ _redirect: true });

	}

	componentWillMount() {

		this.getacyear();
	}

	/** get Academic Year **/
	getacyear() {
		$("#showLoader").show();
		GetData('academic/getacyear').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					accyear: responseJson
				});
				var index = responseJson.findIndex(function (obj) {
					return (obj.iscurrent == 1);
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear: responseJson[index].id
				});
				$('#year option').eq(index + 1).prop('selected', true).trigger('change');
				this.getdata();
			}
		});
	}

	getdata() {

		var ac = $("#year").val();
		$("#showLoader").show();
		GetData('exam/getexambyacyear/' + ac).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					posts: responseJson
				});
			}
		});
	}

	render() {

		if (this.state._redirect) {

			return (<Redirect to={'/subject/subjectupdate/' + this.state.idd} />);

		}

		var acyear = this.state.accyear;

		return (
			<div>
				<AcademicPage />
				<div className="animated fadeIn">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<Row>
						{this.state.isedit == 0 ?
							<Col md="5">
								<Card>
									<form action="" method="post" role="form" id="examform" encType="multipart/form-data" onSubmit={this.onSubmit} >
										<CardHeader>
											<strong>Create Exam</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
											Academic Year : &nbsp;&nbsp;
							<select name="acyear" onChange={this.onAcChange} required id="year">
												<option value="">Select Academic Year</option>
												{
													acyear.map(function (item) {
														return <option value={item.id}>{item.value}</option>;
													})
												}
											</select>&nbsp;&nbsp;
						</CardHeader>
										<CardBody>
											<Row>
												<Col md="4">
													<Label htmlFor="name">Exam Name <span className="text-danger">*</span></Label>
												</Col>
												<Col md="8">
													<FormGroup>
														<Input type="text" name="examname" required onChange={this.onChange} />
													</FormGroup>
												</Col>
												<Col md="4">
													<Label htmlFor="name">Department <span className="text-danger">*</span></Label>
												</Col>
												<Col md="8">
													<FormGroup>
														<select name="department" className="form-control" required onChange={this.onChange}>
															<option value="">Select Department</option>
															<option value="Nursery">Nursery</option>
															<option value="Pre-Primary">Pre-Primary</option>
															<option value="Primary">Primary</option>
															<option value="Middle">Middle</option>
															<option value="High">High</option>
															<option value="Senior Secondary">Senior Secondary</option>
														</select>
													</FormGroup>
												</Col>
												<Col md="4">
													<Label htmlFor="name">Start Date <span className="text-danger">*</span></Label>
												</Col>
												<Col md="8">
													<FormGroup>
														<Input type="date" name="sdate" onChange={this.onChange} required />
													</FormGroup>
												</Col>
												<Col md="4">
													<Label htmlFor="name">End Date <span className="text-danger">*</span></Label>
												</Col>
												<Col md="8">
													<FormGroup>
														<Input type="date" name="edate" onChange={this.onChange} required />
													</FormGroup>
												</Col>
											</Row>
										</CardBody>
										<CardFooter>
											<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
											<Button type="reset" size="sm" color="danger" onClick={this.onClick}><i className="fa fa-ban"></i> Reset</Button>
										</CardFooter>
									</form>
								</Card>
							</Col> :
							<Col md="5">
								<Card>
									<form action="" method="post" role="form" id="exameditform" encType="multipart/form-data" onSubmit={this.onUpdateSubmit} >
										<CardHeader>
											<strong>Edit Exam</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
											Academic Year : &nbsp;&nbsp;
							<select name="acyear" onChange={this.onAcChange} required id="year">
												<option value="">Select Academic Year</option>
												{
													acyear.map(function (item) {
														return <option value={item.id}>{item.value}</option>;
													})
												}
											</select>&nbsp;&nbsp;
							<Button type="reset" size="sm" color="info" onClick={this.onClick}>Add</Button>
										</CardHeader>
										<CardBody>
											<Row>
												<Col md="4">
													<Label htmlFor="name">Exam Name <span className="text-danger">*</span></Label>
												</Col>
												<Col md="8">
													<FormGroup>
														<Input type="text" name="examname" required onChange={this.onChange} value={this.state.examname} />
													</FormGroup>
												</Col>
												<Col md="4">
													<Label htmlFor="name">Department <span className="text-danger">*</span></Label>
												</Col>
												<Col md="8">
													<FormGroup>
														<select name="department" className="form-control" required onChange={this.onChange} value={this.state.department} >
															<option value="">Select Department</option>
															<option value="Nursery">Nursery</option>
															<option value="Pre-Primary">Pre-Primary</option>
															<option value="Primary">Primary</option>
															<option value="Middle">Middle</option>
															<option value="High">High</option>
															<option value="Senior Secondary">Senior Secondary</option>
														</select>
													</FormGroup>
												</Col>
												<Col md="4">
													<Label htmlFor="name">Start Date <span className="text-danger">*</span></Label>
												</Col>
												<Col md="8">
													<FormGroup>
														<Input type="date" name="sdate" onChange={this.onChange} required value={this.state.sdate} />
													</FormGroup>
												</Col>
												<Col md="4">
													<Label htmlFor="name">End Date <span className="text-danger">*</span></Label>
												</Col>
												<Col md="8">
													<FormGroup>
														<Input type="date" name="edate" onChange={this.onChange} required value={this.state.edate} />
													</FormGroup>
												</Col>
											</Row>
										</CardBody>
										<CardFooter>
											<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Update</Button>
										</CardFooter>
									</form>
								</Card>
							</Col>}
						<Col md="7">
							<Card>
								<CardBody>
									<Table responsive bordered>
										<thead>
											<tr>
												<th>S.No</th>
												<th>Exam Name</th>
												<th>Department</th>
												<th>Start Date</th>
												<th>End Date</th>
												<th width="100">Manage</th>
											</tr>
										</thead>
										<tbody>
											{this.state.posts.map(item =>

												<tr key={item}>
													<td>{item.id}</td>
													<td>{item.exam}</td>
													<td>{item.department}</td>
													<td>{item.startdate}</td>
													<td>{item.enddate}</td>
													<td>
														<button name="editexam" className="btn btn-info btn-sm" onClick={() => this.handleEditClick(item.id)} ><i className="fa fa-edit"></i></button>&nbsp;
										<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>
													</td>
												</tr>

											)}
										</tbody>
									</Table>
								</CardBody>
							</Card>
						</Col>
					</Row>
				</div>
			</div>
		)
	}
}

export default SetExam;


// WEBPACK FOOTER //
// ./src/exams/SetExam/SetExam.js